class Stack {

  constructor() {
    this.queue = [];
  }

  pop() {
    this.queue.pop();
  }

  push(val) {
    this.queue.push(val);
  }

  length() {
    return this.queue.length;
  }

  clear() {
    this.queue = [];
  }

  isEmpty() {
    return this.length() === 0;
  }

  first() {
    if (this.isEmpty()) {
      return null;
    }

    return this.queue[this.length() - 1];
  }

  second() {
    if (this.isEmpty() || this.length() === 1) {
      return null;
    }

    return this.queue[this.length() - 2];
  }
}

export default Stack;
